$(document).on "turbolinks:load", ->
  flatpickr ".datepicker", {
    altInput: true,
    altFormat: "j F Y"
  }
